module.exports = __webpack_public_path__ + "static/media/image1.49714ea1.png";